<button (click)="openCreate()" class="btn btn-primary-outline add-button">Add</button>
<h4>Banking Collection</h4>

@if (bankingSettings().length > 0) {
  <app-sortable-table [headers]="headers">
    @for (banking of bankingSettings(); track banking) {
      <tr>
        <td>{{ banking.days | enumArrayParse }}</td>
        <td>{{ banking.startDate | dateParse | dateFormat: 'ddd, D MMM YYYY' }}</td>
        <td>
          @if (canEditAtDate(banking.startDate)) {
            <i
                    (click)="openUpdate(banking)"
                    class="fa fa-xs fa-pen pointer me-1">
            </i>
          }
          @if (canEditAtDate(banking.startDate)) {
            <i
                    (click)="openDelete(banking.startDate)"
                    class="fa fa-xs fa-trash pointer">
            </i>
          }
        </td>
      </tr>
    }
  </app-sortable-table>
}
